import { GroupType } from "../services/types/staff.type";
import EnumDataSource from "../utils/enum-data-source.util";

export const GROUP_AUDIOLOGISTS = "Audiologists";
export const GROUP_BILLING_SPECIALISTS = "Billing specialists";
export const GROUP_BUSINESS_OWNERS = "Business owners";
export const GROUP_FRONT_OFFICE = "Front Office";
export const GROUP_PATIENT_CARE_COORDINATOR = "Patient Care Coordinator";
export const GROUP_ADMINISTRATORS = "Administrators";
export const GROUP_SUNO = "Suno";
export const GROUP_SCHEDULER = "Scheduler";

export const GROUP_BUSINESS_OWNERS_ID = 2;
export const GROUP_BILLING_SPECIALISTS_ID = 3;
const GROUP_WEB_SCHEDULER_ID = 6;
export const GROUP_SUNO_ID = 34;
const GROUP_PATIENTS_ID = 100;
const GROUP_CHICAGOLAND_AUDIOLOGISTS_ID = 133;
const GROUP_CHICAGOLAND_PCC_ID = 166;
export const GROUP_BUSINESS_OWNER_ID = 4;
export const GROUP_ADMINISTRATOR_ID = 67;
export const GROUP_PATIENT_CARE_COORDINATOR_ID = 5;
export const GROUP_SCHEDULER_ID = 232; // PROD
// MASTER: 11, LOCALLY will be different per user

const groups = {
  1: GROUP_AUDIOLOGISTS,
  [GROUP_BUSINESS_OWNERS_ID]: GROUP_FRONT_OFFICE,
  [GROUP_BILLING_SPECIALISTS_ID]: GROUP_BILLING_SPECIALISTS,
  [GROUP_BUSINESS_OWNER_ID]: GROUP_BUSINESS_OWNERS,
  [GROUP_PATIENT_CARE_COORDINATOR_ID]: GROUP_PATIENT_CARE_COORDINATOR,
  [GROUP_WEB_SCHEDULER_ID]: "Web Scheduler",
  [GROUP_SUNO_ID]: GROUP_SUNO,
  [GROUP_ADMINISTRATOR_ID]: GROUP_ADMINISTRATORS,
  [GROUP_SCHEDULER_ID]: GROUP_SCHEDULER,
  [GROUP_PATIENTS_ID]: "Patients",
  [GROUP_CHICAGOLAND_AUDIOLOGISTS_ID]: "Chicagoland Audiologists",
  [GROUP_CHICAGOLAND_PCC_ID]: "Chicagoland PCC"
};

export const VIEW_ONLY_GROUPS = [
  GROUP_WEB_SCHEDULER_ID,
  GROUP_PATIENTS_ID,
  GROUP_SUNO_ID,
  GROUP_SCHEDULER_ID
];

export const ADMIN_LEVEL_GROUPS: GroupType[] = [
  GROUP_BUSINESS_OWNERS,
  GROUP_ADMINISTRATORS,
  GROUP_SUNO
];

export const CHICAGOLAND_GROUPS = [
  GROUP_CHICAGOLAND_AUDIOLOGISTS_ID,
  GROUP_CHICAGOLAND_PCC_ID
];

export const GROUPS = new EnumDataSource(groups);
